import React from "react";
import "./style.css";

function Footer() {
  return (

 <footer class="page-footer fixed-bottom font-small color blue pt-4">

      <div class="footer-copyright text-center py-3">
        © 2021 Stephen Dever
        
      </div>
    </footer>
  );
}

export default Footer;